import * as React from "react"
import { Typography } from '@mui/material'


export default function eanColumn() {
return {
		name: 'Ean',
		label: 'Ean',
		options: {
			customBodyRowRenderLite: value => <Typography sx={{ textAlign: 'center' }}>
				{value || '-'}
			</Typography>
		}
	}
}